module.exports = __webpack_public_path__ + "static/media/star_border.54e7aa3f.svg";